const $4664219393ae548d$export$ca000e230c0caa3e = {
    daily: [],
    weekly: [],
    monthly: [],
    yearly: []
};
const $4664219393ae548d$var$persistData = function() {
    localStorage.setItem("azm_goals", JSON.stringify($4664219393ae548d$export$ca000e230c0caa3e));
};
function $4664219393ae548d$export$5f43677de54231b0(goalData) {
    const { title: title, importance: importance, urgency: urgency, timeframe: timeframe } = goalData;
    const newGoal = {
        id: Date.now(),
        title: title,
        importance: importance,
        urgency: urgency,
        completed: false,
        createdAt: new Date().toISOString()
    };
    if ($4664219393ae548d$export$ca000e230c0caa3e[timeframe]) {
        $4664219393ae548d$export$ca000e230c0caa3e[timeframe].push(newGoal);
        $4664219393ae548d$var$persistData();
    } else throw new Error(`Timeframe "${timeframe}" does not exist in state.`);
}
function $4664219393ae548d$export$458fa9c8ff54e06(id, timeframe) {
    if (!$4664219393ae548d$export$ca000e230c0caa3e.hasOwnProperty(timeframe)) throw new Error(`Timeframe "${timeframe}" does not exist in state.`);
    $4664219393ae548d$export$ca000e230c0caa3e[timeframe] = $4664219393ae548d$export$ca000e230c0caa3e[timeframe].filter((goal)=>goal.id !== id);
    $4664219393ae548d$var$persistData();
}
function $4664219393ae548d$export$ebf09c52417478c6(id, timeframe) {
    const goal = $4664219393ae548d$export$ca000e230c0caa3e[timeframe].find((g)=>g.id === id);
    if (goal) {
        goal.completed = !goal.completed;
        $4664219393ae548d$var$persistData();
    }
}
function $4664219393ae548d$export$ea32cbdd559da174() {
    const storage = localStorage.getItem("azm_goals");
    if (storage) {
        const data = JSON.parse(storage);
        Object.assign($4664219393ae548d$export$ca000e230c0caa3e, data);
    }
}
const $4664219393ae548d$export$1947d5eba3dbedea = function(timeframe) {
    const goals = $4664219393ae548d$export$ca000e230c0caa3e[timeframe];
    if (!goals || goals.length === 0) return 0;
    const completedCount = goals.filter((g)=>g.completed).length;
    return Math.round(completedCount / goals.length * 100);
};
const $4664219393ae548d$export$a4ee4a7c08c40989 = function(timeframe) {
    $4664219393ae548d$export$ca000e230c0caa3e[timeframe] = $4664219393ae548d$export$ca000e230c0caa3e[timeframe].filter((g)=>!g.completed);
    $4664219393ae548d$var$persistData();
};
const $4664219393ae548d$export$7fde8248eab10ddb = function(timeframe) {
    $4664219393ae548d$export$ca000e230c0caa3e[timeframe] = [];
    $4664219393ae548d$var$persistData();
};
const $4664219393ae548d$export$5bc63ccc6c5842 = function(id, timeframe, updates) {
    const goal = $4664219393ae548d$export$ca000e230c0caa3e[timeframe].find((g)=>g.id === id);
    if (goal) {
        // updates could be { importance: 'high', urgency: 'urgent' }
        Object.assign(goal, updates);
        $4664219393ae548d$var$persistData();
    }
};
const $4664219393ae548d$export$1782e38c7770d010 = function(timeframe) {
    const goals = $4664219393ae548d$export$ca000e230c0caa3e[timeframe];
    return {
        doFirst: goals.filter((g)=>g.importance === "high" && g.urgency === "urgent"),
        schedule: goals.filter((g)=>g.importance === "high" && g.urgency === "not-urgent"),
        delegate: goals.filter((g)=>g.importance === "low" && g.urgency === "urgent"),
        eliminate: goals.filter((g)=>g.importance === "low" && g.urgency === "not-urgent")
    };
};
function $4664219393ae548d$export$dbf4eaf81c7ef127(timeframe, newIdArray) {
    const reordered = newIdArray.map((id)=>$4664219393ae548d$export$ca000e230c0caa3e[timeframe].find((g)=>g.id == id));
    $4664219393ae548d$export$ca000e230c0caa3e[timeframe] = reordered.filter((el)=>el !== undefined);
    $4664219393ae548d$var$persistData();
}


class $6f0030787aa6e989$var$FormView {
    constructor(){
        this.form = document.getElementById("taskForm");
        this.titleInput = document.getElementById("title");
        this.importanceInput = document.getElementById("importance");
        this.urgencyInput = document.getElementById("urgency");
        this.timeframeInput = document.getElementById("timeframe");
    }
    _getFormData() {
        return {
            title: this.titleInput.value.trim(),
            importance: this.importanceInput.value,
            urgency: this.urgencyInput.value,
            timeframe: this.timeframeInput.value
        };
    }
    addEventListener(handler) {
        this.form.addEventListener("submit", (e)=>{
            e.preventDefault();
            handler();
        });
    }
    _clearInputs() {
        this.form.reset();
        this.titleInput.focus();
    }
}
var $6f0030787aa6e989$export$2e2bcd8739ae039 = new $6f0030787aa6e989$var$FormView();


class $cffc94aa684daba9$var$FilterView {
    constructor(){
        this.parentElement = document.querySelector(".filter-nav");
    // We select buttons dynamically in methods to avoid stale references
    }
    // Helper to get buttons on the fly
    get _buttons() {
        return this.parentElement.querySelectorAll("button");
    }
    addEventListener(handler) {
        this.parentElement.addEventListener("click", (e)=>{
            const btn = e.target.closest("button");
            if (!btn) return;
            const filter = btn.dataset.filter;
            this._updateActiveButton(btn);
            handler(filter);
        });
    }
    _updateActiveButton(activeBtn) {
        this._buttons.forEach((btn)=>btn.classList.remove("selectedFilter"));
        activeBtn.classList.add("selectedFilter");
    }
    getActiveFilter() {
        const activeBtn = Array.from(this._buttons).find((btn)=>btn.classList.contains("selectedFilter"));
        return activeBtn ? activeBtn.dataset.filter : "daily";
    }
    // NEW: Call this from the controller to switch tabs programmatically
    setActiveFilter(filter) {
        const targetBtn = Array.from(this._buttons).find((btn)=>btn.dataset.filter === filter);
        if (targetBtn) this._updateActiveButton(targetBtn);
    }
}
var $cffc94aa684daba9$export$2e2bcd8739ae039 = new $cffc94aa684daba9$var$FilterView();


class $767b5528b2e5b329$var$GoalListView {
    constructor(){
        this.parentElement = document.getElementById("goalsList");
        this.taskCountElement = document.getElementById("taskCount");
    }
    /**
   * Renders the goals list with progress bar and action buttons
   * @param {Array} goals - The list of goals to display
   * @param {Number} progress - Completion percentage (0-100)
   */ render(goals, progress = 0) {
        this.parentElement.innerHTML = "";
        // 1. Create Progress and Actions Header
        const headerMarkup = `
      <div class="progress-container">
        <div class="progress-bar" style="width: ${progress}%"></div>
      </div>
      <div class="actions-bar">
        <button type="button" class="text-btn clear-completed-btn">Clear Completed</button>
        <button type="button" class="text-btn clear-all-btn">Clear All</button>
      </div>
    `;
        this.parentElement.insertAdjacentHTML("afterbegin", headerMarkup);
        // 2. Handle Empty State
        if (goals.length === 0) {
            this.parentElement.insertAdjacentHTML("beforeend", `<p class="empty-msg">No goals found for this period.</p>`);
            this._updateTaskCount(0);
            return;
        }
        // 3. Render Goals
        const markup = goals.map((goal)=>this._generateMarkup(goal)).join("");
        this.parentElement.insertAdjacentHTML("beforeend", markup);
        this._updateTaskCount(goals.length);
    }
    /**
   * Updated to handle Delete, Toggle, Clear Completed, and Clear All
   */ addEventListener(handlerDelete, handlerToggle, handlerClearCompleted, handlerClearAll) {
        this.parentElement.addEventListener("click", (e)=>{
            const deleteBtn = e.target.closest(".delete-btn");
            const checkbox = e.target.closest(".task-checkbox");
            const clearCompletedBtn = e.target.closest(".clear-completed-btn");
            const clearAllBtn = e.target.closest(".clear-all-btn");
            if (deleteBtn) {
                const id = Number(deleteBtn.dataset.id);
                handlerDelete(id);
            }
            if (checkbox) {
                const id = Number(checkbox.dataset.id);
                handlerToggle(id);
            }
            if (clearCompletedBtn) handlerClearCompleted();
            if (clearAllBtn) {
                if (confirm("Are you sure you want to delete all goals in this timeframe?")) handlerClearAll();
            }
        });
    }
    _generateMarkup(goal) {
        return `
      <li class="goal-item ${goal.importance === "high" ? "important" : "not-important"} ${goal.completed ? "completed" : ""}" 
          draggable="true" 
          data-id="${goal.id}">
        <div class="goal-content">
          <p class="goal-title">${goal.title}</p>
          <div class="tags-container">
            <span class="tag ${goal.importance}">${goal.importance}</span>
            <span class="tag ${goal.urgency}">${goal.urgency}</span>
          </div>
        </div>
        <div class="goal-action">
          <input type="checkbox" class="task-checkbox" data-id="${goal.id}" ${goal.completed ? "checked" : ""} />
          <button type="button" class="delete-btn" data-id="${goal.id}">
            <i class="fa-solid fa-xmark"></i>
          </button>
        </div>
      </li>
    `;
    }
    addDragListeners(handlerReorder) {
        this.parentElement.addEventListener("dragstart", (e)=>{
            const item = e.target.closest(".goal-item");
            if (item) item.classList.add("dragging");
        });
        this.parentElement.addEventListener("dragend", (e)=>{
            const item = e.target.closest(".goal-item");
            if (item) item.classList.remove("dragging");
            const newOrderIds = Array.from(this.parentElement.querySelectorAll(".goal-item")).map((el)=>Number(el.dataset.id));
            handlerReorder(newOrderIds);
        });
        this.parentElement.addEventListener("dragover", (e)=>{
            e.preventDefault();
            const draggingItem = document.querySelector(".dragging");
            if (!draggingItem) return;
            const siblings = [
                ...this.parentElement.querySelectorAll(".goal-item:not(.dragging)")
            ];
            const nextSibling = siblings.find((sibling)=>{
                return e.clientY <= sibling.offsetTop + sibling.offsetHeight / 2;
            });
            this.parentElement.insertBefore(draggingItem, nextSibling);
        });
    }
    _updateTaskCount(count) {
        this.taskCountElement.textContent = count;
    }
}
var $767b5528b2e5b329$export$2e2bcd8739ae039 = new $767b5528b2e5b329$var$GoalListView();


// views/MatrixView.js
class $2ea12a5a11cb8fff$var$MatrixView {
    constructor(){
        this.parentElement = document.getElementById("matrixContainer");
    }
    /**
   * Renders the 2x2 Eisenhower Matrix
   * @param {Object} data - Categorized goals (doFirst, schedule, delegate, eliminate)
   */ render(data) {
        if (!this.parentElement) return;
        const grid = this.parentElement.querySelector(".matrix-grid");
        const markup = `
      <div class="quadrant" id="doFirst">
        <h3 class="q-title q-do">Do First</h3>
        <div class="q-list">${this._generateList(data.doFirst)}</div>
      </div>
      <div class="quadrant" id="schedule">
        <h3 class="q-title q-schedule">Schedule</h3>
        <div class="q-list">${this._generateList(data.schedule)}</div>
      </div>
      <div class="quadrant" id="delegate">
        <h3 class="q-title q-delegate">Delegate</h3>
        <div class="q-list">${this._generateList(data.delegate)}</div>
      </div>
      <div class="quadrant" id="eliminate">
        <h3 class="q-title q-eliminate">Eliminate</h3>
        <div class="q-list">${this._generateList(data.eliminate)}</div>
      </div>
    `;
        grid.innerHTML = markup;
    }
    /**
   * Adds listener for the Quick-Move feature
   */ addQuickMoveListener(handler) {
        this.parentElement.addEventListener("click", (e)=>{
            const moveBtn = e.target.closest(".move-btn");
            if (!moveBtn) return;
            const id = Number(moveBtn.dataset.id);
            const currentImportance = moveBtn.dataset.importance;
            const currentUrgency = moveBtn.dataset.urgency;
            // Logic to "cycle" the task to the next quadrant
            let nextImportance = currentImportance;
            let nextUrgency = currentUrgency;
            if (currentImportance === "high" && currentUrgency === "urgent") nextUrgency = "not-urgent"; // Move to Schedule
            else if (currentImportance === "high" && currentUrgency === "not-urgent") {
                nextImportance = "low";
                nextUrgency = "urgent"; // Move to Delegate
            } else if (currentImportance === "low" && currentUrgency === "urgent") nextUrgency = "not-urgent"; // Move to Eliminate
            else {
                nextImportance = "high";
                nextUrgency = "urgent"; // Loop back to Do First
            }
            handler(id, {
                importance: nextImportance,
                urgency: nextUrgency
            });
        });
    }
    _generateList(goals) {
        if (goals.length === 0) return `<p class="empty-msg">No tasks</p>`;
        return goals.map((g)=>`
      <div class="matrix-item priority-${g.importance} ${g.completed ? "completed" : ""}">
        ${g.completed ? '<i class="fa-solid fa-check" style="margin-right: 8px; color: var(--success);"></i>' : ""}
        <span>${g.title}</span>
        <button class="move-btn text-btn" 
                data-id="${g.id}" 
                data-importance="${g.importance}" 
                data-urgency="${g.urgency}" 
                title="Move to next quadrant">
          <i class="fa-solid fa-arrows-rotate"></i>
        </button>
      </div>`).join("");
    }
}
var $2ea12a5a11cb8fff$export$2e2bcd8739ae039 = new $2ea12a5a11cb8fff$var$MatrixView();


const $3487b967fc5e768d$var$controlAddGoal = function() {
    const data = (0, $6f0030787aa6e989$export$2e2bcd8739ae039)._getFormData();
    if (!data.title) return;
    $4664219393ae548d$export$5f43677de54231b0(data);
    (0, $6f0030787aa6e989$export$2e2bcd8739ae039)._clearInputs();
    (0, $cffc94aa684daba9$export$2e2bcd8739ae039).setActiveFilter(data.timeframe);
    $3487b967fc5e768d$var$updateUI();
};
const $3487b967fc5e768d$var$controlDeleteGoal = function(id) {
    const activeFilter = (0, $cffc94aa684daba9$export$2e2bcd8739ae039).getActiveFilter();
    $4664219393ae548d$export$458fa9c8ff54e06(id, activeFilter);
    $3487b967fc5e768d$var$updateUI();
};
const $3487b967fc5e768d$var$controlToggleGoal = function(id) {
    const activeFilter = (0, $cffc94aa684daba9$export$2e2bcd8739ae039).getActiveFilter();
    $4664219393ae548d$export$ebf09c52417478c6(id, activeFilter);
    $3487b967fc5e768d$var$updateUI();
};
/**
 * NEW: Handles clearing completed tasks
 */ const $3487b967fc5e768d$var$controlClearCompleted = function() {
    const activeFilter = (0, $cffc94aa684daba9$export$2e2bcd8739ae039).getActiveFilter();
    $4664219393ae548d$export$a4ee4a7c08c40989(activeFilter);
    $3487b967fc5e768d$var$updateUI();
};
/**
 * NEW: Handles clearing the entire timeframe
 */ const $3487b967fc5e768d$var$controlClearAll = function() {
    const activeFilter = (0, $cffc94aa684daba9$export$2e2bcd8739ae039).getActiveFilter();
    $4664219393ae548d$export$7fde8248eab10ddb(activeFilter);
    $3487b967fc5e768d$var$updateUI();
};
/**
 * NEW: Handles the Quick-Move rotation in the Matrix
 */ const $3487b967fc5e768d$var$controlQuickMove = function(id, updates) {
    const activeFilter = (0, $cffc94aa684daba9$export$2e2bcd8739ae039).getActiveFilter();
    $4664219393ae548d$export$5bc63ccc6c5842(id, activeFilter, updates);
    $3487b967fc5e768d$var$updateUI();
};
const $3487b967fc5e768d$var$controlFilter = function() {
    $3487b967fc5e768d$var$updateUI();
};
const $3487b967fc5e768d$var$controlReorder = function(newIdArray) {
    const activeFilter = (0, $cffc94aa684daba9$export$2e2bcd8739ae039).getActiveFilter();
    $4664219393ae548d$export$dbf4eaf81c7ef127(activeFilter, newIdArray);
};
/**
 * UPDATED: Now passes progress data to the GoalListView
 */ const $3487b967fc5e768d$var$updateUI = function() {
    const activeFilter = (0, $cffc94aa684daba9$export$2e2bcd8739ae039).getActiveFilter();
    const goals = $4664219393ae548d$export$ca000e230c0caa3e[activeFilter];
    // Get progress percentage (0-100)
    const progress = $4664219393ae548d$export$1947d5eba3dbedea(activeFilter);
    // 1. Update List View with goals and progress
    (0, $767b5528b2e5b329$export$2e2bcd8739ae039).render(goals, progress);
    // 2. Update Matrix View
    const matrixData = $4664219393ae548d$export$1782e38c7770d010(activeFilter);
    (0, $2ea12a5a11cb8fff$export$2e2bcd8739ae039).render(matrixData);
};
const $3487b967fc5e768d$var$controlViewSwitch = function(viewType) {
    const listContainer = document.getElementById("listContainer");
    const matrixContainer = document.getElementById("matrixContainer");
    const listBtn = document.getElementById("listViewBtn");
    const matrixBtn = document.getElementById("matrixViewBtn");
    if (viewType === "list") {
        listContainer.classList.remove("hidden");
        matrixContainer.classList.add("hidden");
        listBtn.classList.add("active-view");
        matrixBtn.classList.remove("active-view");
    } else {
        listContainer.classList.add("hidden");
        matrixContainer.classList.remove("hidden");
        listBtn.classList.remove("active-view");
        matrixBtn.classList.add("active-view");
    }
};
const $3487b967fc5e768d$var$controlTheme = function() {
    const isDark = document.body.classList.toggle("dark-mode");
    // Update Icon
    const icon = document.querySelector("#themeToggle i");
    icon.classList.toggle("fa-sun", isDark);
    icon.classList.toggle("fa-moon", !isDark);
    // Save preference
    localStorage.setItem("azm_theme", isDark ? "dark" : "light");
};
const $3487b967fc5e768d$var$init = function() {
    $4664219393ae548d$export$ea32cbdd559da174();
    // 1. Theme Initialization
    const savedTheme = localStorage.getItem("azm_theme");
    const themeBtn = document.getElementById("themeToggle");
    const themeIcon = themeBtn?.querySelector("i");
    if (savedTheme === "dark") {
        document.body.classList.add("dark-mode");
        if (themeIcon) themeIcon.classList.replace("fa-moon", "fa-sun");
    }
    // 2. Set Default View
    $3487b967fc5e768d$var$controlViewSwitch("list");
    // 3. Application Event Listeners
    (0, $6f0030787aa6e989$export$2e2bcd8739ae039).addEventListener($3487b967fc5e768d$var$controlAddGoal);
    (0, $cffc94aa684daba9$export$2e2bcd8739ae039).addEventListener($3487b967fc5e768d$var$controlFilter);
    (0, $767b5528b2e5b329$export$2e2bcd8739ae039).addEventListener($3487b967fc5e768d$var$controlDeleteGoal, $3487b967fc5e768d$var$controlToggleGoal, $3487b967fc5e768d$var$controlClearCompleted, $3487b967fc5e768d$var$controlClearAll);
    (0, $767b5528b2e5b329$export$2e2bcd8739ae039).addDragListeners($3487b967fc5e768d$var$controlReorder);
    (0, $2ea12a5a11cb8fff$export$2e2bcd8739ae039).addQuickMoveListener($3487b967fc5e768d$var$controlQuickMove);
    // 4. UI Component Listeners
    document.getElementById("listViewBtn").addEventListener("click", ()=>$3487b967fc5e768d$var$controlViewSwitch("list"));
    document.getElementById("matrixViewBtn").addEventListener("click", ()=>$3487b967fc5e768d$var$controlViewSwitch("matrix"));
    // 5. Theme Toggle Listener
    themeBtn?.addEventListener("click", ()=>{
        const isDark = document.body.classList.toggle("dark-mode");
        // Update Icon visually
        if (themeIcon) {
            themeIcon.classList.toggle("fa-sun", isDark);
            themeIcon.classList.toggle("fa-moon", !isDark);
        }
        // Persist preference
        localStorage.setItem("azm_theme", isDark ? "dark" : "light");
    });
    // 6. Final Initial Render
    $3487b967fc5e768d$var$updateUI();
};
$3487b967fc5e768d$var$init();


//# sourceMappingURL=repo.32731a9c.js.map
